import {createContext, useState, useEffect, useContext} from 'react';


export const ChabotDetailsContext = createContext();

//Context that will live during the user session
export const ChatbotDetailsProvider = ({children}) => {
    const [globalConversation_id, setGlobalConversation_id] = useState(null);
    const [selectedHistoricalParams, setSelectedHistoricalParams] = useState(null);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);


    const openDrawer = () => setIsDrawerOpen(true);
    const closeDrawer = () => setIsDrawerOpen(false);
    const toggleDrawer = () => setIsDrawerOpen((prev) => !prev);


    return (
        <ChabotDetailsContext.Provider
            value={{globalConversation_id,
                setGlobalConversation_id,
                selectedHistoricalParams,
                setSelectedHistoricalParams,
                isDrawerOpen,
                openDrawer,
                closeDrawer,
                toggleDrawer,
            }}>
            {children}
        </ChabotDetailsContext.Provider>
    );
};
export const  useChatbotContext = () => {
    const context = useContext(ChabotDetailsContext);

    if (context === undefined) {
        throw new Error('useContextProvider must be used within ContextProvider.');
    }

    return context;

}
